/* eslint-disable */
import { Fragment } from 'react';
import ReactDOM from 'react-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import AddresbookTabs from './Tabsaddressbook';
import AppSearchBar from '@crema/core/AppSearchBar';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PilihanAddressbook from './PilihanAddressbook';
import { PeopleRounded } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { FETCH_START, FETCH_SUCCESS } from 'shared/constants/ActionTypes';
import jwtAxios from '@crema/services/auth/jwt-auth';
import { API } from 'shared/constants/AppEnums';
import InfoDialog from '../InfoDialog';
import useModal from 'shared/hooks/useModal';
import { ButtonContained, ButtonOutlined } from '../Button';
import { getDivisions } from 'redux/actions/Divisi';
function PaperComponent(props) {
  return (
    <Draggable
      handle='#addressbook-nde'
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  }
}));


const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  // height:'285px',
  height: '100%',
  minWidth: '100%',
  paddingTop: 0
}));


const Addressbook = ({ stateAddress, toggleHide, setPayloadOnHide, config }) => {
  const { title, tabs, multiselect, payloadPilihan, hideDivisi, defaultDivision, useCRSFE, closed, isTransform, eselon1 = true, eselon2 = true} = config;
  const [pilihan, setPilihan] = useState(payloadPilihan);
  const [personal, setPersonal] = useState('');
  const [searchText, setSearchText] = useState('');
  const [displaySearchText, setDisplaySearchText] = useState('');
  const dispatch = useDispatch();
  const { stateAddress: stateInfo, toggleShow: toggleShowInfo, toggleHide: toggleHideInfo } = useModal();
  const [infoMsg, setInfo] = useState('');
  useEffect(() => {
    setPilihan(payloadPilihan);
  }, [payloadPilihan, title]);

  useEffect(() => {
    dispatch(getDivisions(useCRSFE));
  }, [stateAddress]);

  const handleOk = () => {
    setPayloadOnHide(pilihan);
    removeSearch();
  };

  const handlePayloadOnHideCustom = (data) => {
    removeSearch();
    setPayloadOnHide(data);
  }

  const handleCancel = () => {
    toggleHide(true);
    removeSearch();
  };

  const handleAddPersonal = () => {
    if (!personal) {
      setInfo("Pilih Profle terlebihi dahulu !");
      toggleShowInfo(true);
    } else {
      const postdata = { code: personal.code };
      dispatch({ type: FETCH_START });
      jwtAxios.post(API.ADD_PERSONAL, JSON.stringify(postdata), API.requestOptionsPOST()).then(
        (data) => {
          if (data.status === 200) {
            let tmpName = personal.title ? personal.title : personal.name;
            dispatch({ type: FETCH_SUCCESS });
            setInfo("Berhasil Menambahkan " + tmpName + " ke personal");
            toggleShowInfo(true);
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: messages['message.somethingWentWrong'],
            });
          }
        },
        (error) => {
          dispatch({ type: FETCH_SUCCESS });
          setInfo(error.response.data.message);
          toggleShowInfo(true);
        }
      );
    }

  };

  const handleSearchText = (event) => {
    if (event.key === 'Enter') {
      setSearchText((prev) => {
        return event.target.value;
      });
    } else if (event.key === 'Delete') {
      removeSearch();
    }
  };

  const handleChange = (text) => {
    setDisplaySearchText(text);
  }

  const removeSearch = () => {
    setSearchText('');
    setDisplaySearchText('');
  };
  return (
    stateAddress.show ? ReactDOM.createPortal(
      <Fragment>
        <div>
          <BootstrapDialog
            open={stateAddress.show}
            onClose={toggleHide}
            PaperComponent={PaperComponent}
            aria-labelledby='addressbook-nde'
            aria-describedby='alert-dialog-description'
            PaperProps={{
              sx: {
                m: 0,
                top: 10,
                left: 10,
                width: '750px',
                height: '400px',
                maxWidth: '750px'
              }
            }}
          >
            <DialogContent
              dividers
              sx={{
                padding: '0 !important',
                height: '100%',
                overflow: 'hidden'
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  height: '100%',
                  marginTop: '10px'
                }}
              >
                <Grid
                  container
                  spacing={2}
                  sx={{
                    height: '100%',
                  }}
                >
                  <Grid
                    item
                    xs={multiselect ? 8 : 12}
                    sx={{
                      overflowX: 'auto',
                      overflowY: 'hidden',
                      paddingTop: '0px !important',
                      borderRight: 'solid 1px lightgray',
                      height: '100%'
                    }}
                  >
                    <Item>
                      <AddresbookTabs
                        tabs={tabs}
                        multiselect={multiselect}
                        setPayloadOnHide={handlePayloadOnHideCustom}
                        setPilihan={setPilihan}
                        pilihan={pilihan}
                        searchText={searchText}
                        removeSearch={removeSearch}
                        setPersonal={setPersonal}
                        hideDivisi={hideDivisi}
                        defaultDivision={defaultDivision}
                        useCRSFE={useCRSFE}
                        isTransform={isTransform}
                        closed={closed}
                        eselon1={eselon1}
                        eselon2={eselon2}
                      />
                    </Item>
                  </Grid>
                  {multiselect &&
                    <Grid item xs={4} sx={{
                      padding: '0 !important'
                    }}>
                      <Box component="div" sx={{
                        p: 2,
                        border: '1px solid lightgray',
                        background: '#800000',
                        color: 'white',
                        fontWeight: '700'
                      }}>
                        Pilihan
                      </Box>
                      <PilihanAddressbook
                        pilihan={pilihan}
                        setPilihan={setPilihan}
                      />
                    </Grid>
                  }

                </Grid>
              </Box>
            </DialogContent>
            <DialogActions>
              <AppSearchBar
                // sx={{ display: 'none' }}
                width='420px'
                iconPosition='left'
                overlap={true}
                value={displaySearchText}
                onChange={(event) => handleChange(event.target.value)}
                onKeyDown={handleSearchText}
                placeholder='Kata Kunci...'
              />
              <div style={{ flex: '1 0 0' }} />
              <Button sx={{ display: 'none' }} variant="contained" color="info" onClick={() => handleAddPersonal()}>
                <PeopleRounded
                  style={{
                    fontSize: '20pt',
                    marginRight: '10px'
                  }}
                /> Add to Personal
              </Button>
              <ButtonOutlined variant='outlined' onClick={() => handleCancel()}>Batal</ButtonOutlined>
              <ButtonContained variant='contained' onClick={() => handleOk()}>Simpan</ButtonContained>
            </DialogActions>
          </BootstrapDialog>
        </div>
        <InfoDialog
          stateAddress={stateInfo}
          toggleHide={toggleHideInfo}
          msg={infoMsg}
        />
      </Fragment>, document.body
    ) : null
  );
};

export default Addressbook;

Addressbook.propTypes = {
  stateAddress: PropTypes.object,
  toggleHide: PropTypes.func,
  config: PropTypes.object,
  setPayloadOnHide: PropTypes.any
};